import { HttpClient, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IProductCost, IProductForm, IProductList, IProductSingle } from "./models/products";

@Injectable({
  providedIn: "root",
})
export class ProductsService {
  public productsList: IProductList[] = [];
  private productsUrl: string = "/product";
  constructor(private http: HttpClient) {}

  async getProductsList() {
    return this.http.get<IProductList[]>(this.productsUrl).toPromise();
  }

  async getProduct(id: number) {
    return this.http.get<IProductSingle>(`${this.productsUrl}/${id}`).toPromise();
  }

  async createProduct(data: IProductForm) {
    return this.http.post<IProductForm>(this.productsUrl, data).toPromise();
  }

  async editProduct(id: number, data: IProductForm) {
    return this.http.put<IProductForm>(`${this.productsUrl}/${id}`, data).toPromise();
  }

  async deleteProduct(id: number) {
    return this.http.delete(`${this.productsUrl}/${id}`).toPromise();
  }

  async uploadAttachmentProduct(file: any, id: number) {
    const formData: FormData = new FormData();
    formData.append("file", file);
    const req: any = new HttpRequest("POST", `/product/attachment/${id}`, formData);
    return this.http.request(req).toPromise();
  }

  async deleteAttachmentProduct(id: number) {
    return this.http.delete(`/product/attachment/${id}`).toPromise();
  }

  async updateCost(id: number, data: { monthly_cost: string }) {
    return this.http.put<{ monthly_cost: string }>(`/product/monthly-cost/${id}`, data).toPromise();
  }

  //Restituisce le commesse di un cliente con le statistiche economiche
  async getProductsCostList(month: string, year: string) {
    return this.http.get<IProductCost[]>(`/product/monthly-cost/${month}/${year}`).toPromise();
  }
}
